import { useEffect } from 'react'
import * as React from 'react'
import { useInView } from 'react-intersection-observer'
import { OFFER_TRACKING_IN_VIEW_THRESHOLD } from 'constants/offerList'

interface Props {
  children: React.ReactNode
  scrollRoot: Element | null
  monthKey: string
  monthNumber: number
  year: number
  shouldTrack: boolean
  onImpression: (monthKey: string, monthNumber: number, year: number) => void
}

function CalendarMonthPriceBlockImpression({ children, scrollRoot, monthKey, monthNumber, year, shouldTrack, onImpression }: Props) {
  const [ref, inView] = useInView({
    root: scrollRoot ?? undefined,
    threshold: OFFER_TRACKING_IN_VIEW_THRESHOLD,
    triggerOnce: true,
    skip: !shouldTrack,
  })

  useEffect(() => {
    if (inView) {
      onImpression(monthKey, monthNumber, year)
    }
  }, [inView, onImpression, monthKey, monthNumber, year])

  return <div ref={ref}>{children}</div>
}

export default CalendarMonthPriceBlockImpression
